import fetch from './fetch'

export function startImpl (unitId: number, impl_question_type: number): Promise<api.unitImpl.StartImplResponse> {
  const qs = `impl_question_type=${impl_question_type}`

  return fetch.post(`/units/${unitId}/impl?${qs}`).then(res => res.data)
}

export function getContinueImpl (unitId: number): Promise<api.unitImpl.ContinueImplResponse> {
  return fetch.get(`/units/${unitId}/impl`).then(res => res.data)
}

export function getImpl (unitId: number, id: number): Promise<api.unitImpl.GetImplResponse> {
  return fetch.get(`/units/${unitId}/impls/${id}`).then(res => res.data)
}

export function getImplHistory (unitId: number): Promise<api.unitImpl.GetImplHistoryResponse> {
  return fetch.get(`/units/${unitId}/impl/history`).then(res => res.data)
}

export function updateImplAnswers (unitId: number, questionSeq: number, answers: number[]): Promise<api.EmptyResponse> {
  return fetch.post(`/units/${unitId}/impl/answer`, { question_impl_seq: questionSeq, answers }).then(res => res.data)
}

export function finishImpl (unitId: number, answers: number[][]): Promise<api.EmptyResponse> {
  return fetch.post(`/units/${unitId}/impl/finish`, answers).then(res => res.data)
}

export function updateImplCurrentSeq (unitId: number, seq: number, remaining_time: number): Promise<api.EmptyResponse> {
  return fetch.post(`units/${unitId}/impl/current_seq`, { seq, remaining_time }).then(res => res.data)
}

export function saveImplAnswers (unitId: number, questionSeq: number, answers: number[], remaining_time: number): Promise<api.EmptyResponse> {
  return fetch.post(`/units/${unitId}/impl/save_answers`, { question_impl_seq: questionSeq, answers, remaining_time }).then(res => res.data)
}

export function setPrivateResult(unitId: any, implId: any, check: boolean): Promise<api.EmptyResponse> {
  return fetch.patch(`/units/${unitId}/impls/${implId}/status`, {
    is_private: check
  }).then(res => res.data)
}
